const NAV_CONFIG_ENABLE_VALUES = [true, 1];

export const isNavConfigEnabled = (navItem, configName) => (
    NAV_CONFIG_ENABLE_VALUES.includes(navItem[configName])
);

export const hasSecondaryLevelMenuItemDropdown = (menuItem, hasMainHeaderDropdown) => {
    const hasChildren = (menuItem?.children?.length ?? 0) > 0;
    const hasGrandChildren = (menuItem?.children?.reduce((sum, child) => sum + child.children.length, 0) ?? 0) > 0;

    return hasMainHeaderDropdown ? hasChildren : hasGrandChildren;
};
